<app-organization-sidebar-layout>
  <app-page-header>
    <app-page-title>{{ 'cockpit.locations.page.title' | transloco }}</app-page-title>
    <div slot="end" class="flex flex-row max-[450px]:flex-col gap-2">
      <ui-button
        expand="full"
        data-track="cockpit-location-create-button"
        (click)="createLocationDialog.showModal()"
      >
        <ng-icon slot="start" name="heroMapPin" size="20" class="!block" />
        {{ 'cockpit.locations.page.addLocationButton' | transloco }}
      </ui-button>
    </div>
  </app-page-header>

  <div slot="sticky-header" class="flex gap-3">
    <ui-input-simple
      #search
      type="search"
      class="flex-1 max-w-[320px]"
      data-track="cockpit-location-search"
      [placeholder]="'cockpit.locations.page.searchPlaceholder' | transloco"
      [attr.aria-label]="'cockpit.locations.page.searchAriaLabel' | transloco"
      [formField]="filterForm.query"
      (change)="setFilterQuery(search.value())"
    >
      <div slot="start" class="text-on-surface-disabled dark:text-on-surface-disabled-darkmode">
        <ng-icon name="heroMagnifyingGlass" size="13" class="!block" />
      </div>
    </ui-input-simple>
  </div>

  <div class="flex flex-col gap-5">
    @if (isLoading()) {
      <ul class="flex flex-col gap-3">
        <app-location-list-entry-skeleton />
        <app-location-list-entry-skeleton />
      </ul>
    } @else if (error()) {
      <app-error-page
        [error]="error()"
        (clickBack)="onClickBack()"
        class="block"
        style="height: calc(100vh - 20rem)"
      />
    } @else if (locations().length === 0) {
      @if (filterForm.query().value()) {
        <div
          class="border border-dashed border-outline dark:border-outline-darkmode self-stretch p-6 rounded-lg inline-flex flex-col justify-center items-center gap-3"
        >
          <div class="self-stretch flex flex-col justify-start items-center gap-1">
            <div
              class="self-stretch text-center justify-start text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-5"
            >
              {{ 'cockpit.locations.page.noResultsTitle' | transloco }}
            </div>
            <div
              class="self-stretch text-center justify-start text-on-surface-subtle dark:text-on-surface-subtle-darkmode text-sm font-normal leading-5 max-w-sm m-auto"
            >
              {{ 'cockpit.locations.page.noResultsSubtitle' | transloco }}
            </div>
          </div>
          <div class="flex justify-start items-center gap-3">
            <ui-button mode="outlined" (click)="setFilterQuery('')">
              <ng-icon slot="start" name="heroXCircle" size="20" class="!block" />
              {{ 'cockpit.locations.page.resetButton' | transloco }}
            </ui-button>
          </div>
        </div>
      } @else {
        <app-locations-empty-box (clickAdd)="createLocationDialog.showModal()" />
      }
    } @else {
      @if (organizationId(); as orgId) {
        <app-locations-list [locations]="locations()" [organizationId]="orgId" />
      }
      <app-locations-add-box (clickAdd)="createLocationDialog.showModal()" />
    }
  </div>
</app-organization-sidebar-layout>

<app-tutorial-locations-popover />

<ui-simple-dialog #createLocationDialog>
  <app-location-create-dialog
    class="w-full"
    (clickCancel)="createLocationDialog.close()"
    (createSuccess)="onCreateSuccess($event)"
  />
</ui-simple-dialog>
